module.exports = __webpack_public_path__ + "static/img/zl_btn2.9863696.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/role3/control/zl_btn2.png
// module id = d6yC
// module chunks = 7